import { ActionType, matcher, MatchType } from "@cdv/jazz-ui";
import View from "../ui/View";
import { Resource } from "../utils";
import Content from "./Content";
import ContentShow from "./ContentShow";
import About from "./Abount";
import PersonalData from "./PersonalData";
import Terms from "./Terms";
import Help from "./Help";
import Contact from "./Contact";

export default matcher({ resource: Resource.Info })
  .set(MatchType.View, View)
  .set(MatchType.Content, Content)
  .set(MatchType.Content, ContentShow, { action: ActionType.SHOW })
  .set(MatchType.View, About, { name: "about" })
  .set(MatchType.View, PersonalData, { name: "personal-data" })
  .set(MatchType.View, Terms, { name: "terms" })
  .set(MatchType.View, Help, { name: "help" })
  .set(MatchType.View, Contact, { name: "contact" })
  .entries();
